/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sweet_Loud_Toucan_TwistInputs */

const fr_sweet_loud_toucan_twist = /** @type {(inputs: Sweet_Loud_Toucan_TwistInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modifier l'email`)
};

/**

* @param {Sweet_Loud_Toucan_TwistInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const sweet_loud_toucan_twist = /** @type {((inputs?: Sweet_Loud_Toucan_TwistInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sweet_Loud_Toucan_TwistInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_sweet_loud_toucan_twist(inputs)
});